var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "quotation-detail-page" },
    [
      _c(
        "BjDivider",
        {
          attrs: { "right-fixed": "" },
          scopedSlots: _vm._u([
            {
              key: "right",
              fn: function () {
                return [
                  _c("el-button", { on: { click: _vm.handleClose } }, [
                    _vm._v(_vm._s(_vm.$t("backText"))),
                  ]),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [_c("span", [_vm._v(_vm._s(_vm.$t("QuotationCenter.Details")))])]
      ),
      _c("div", { staticClass: "quotation-shell" }, [
        _c("div", { staticClass: "summary-bar" }, [
          _c("div", { staticClass: "summary-item summary-item--left" }, [
            _c("span", { staticClass: "summary-label" }, [
              _vm._v(_vm._s(_vm.$t("QuotationCenter.supplier")) + ":"),
            ]),
            _c("span", { staticClass: "summary-value" }, [
              _vm._v(_vm._s(_vm.supplierName)),
            ]),
          ]),
          _c("div", { staticClass: "summary-item summary-item--center" }, [
            _c("span", { staticClass: "summary-label" }, [
              _vm._v(_vm._s(_vm.$t("QuotationCenter.logisticsChannel")) + ":"),
            ]),
            _c("span", { staticClass: "summary-value" }, [
              _vm._v(_vm._s(_vm.logisticsChannelName)),
            ]),
          ]),
          _c("div", { staticClass: "summary-item summary-item--right" }, [
            _c("span", { staticClass: "summary-label" }, [
              _vm._v(_vm._s(_vm.$t("QuotationCenter.effectiveTime")) + ":"),
            ]),
            _c("span", { staticClass: "summary-value" }, [
              _vm._v(_vm._s(_vm.effectiveTimeText)),
            ]),
          ]),
        ]),
        _c(
          "div",
          { staticClass: "rate-card" },
          [
            _c(
              "BjDivider",
              [
                _vm._v(
                  " " + _vm._s(_vm.$t("QuotationCenter.shippingFee")) + " "
                ),
                _c(
                  "template",
                  { slot: "right" },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", size: "mini", plain: "" },
                        on: {
                          click: function ($event) {
                            return _vm.$router.push({
                              name: "BusinessQuotationShippingCost",
                              query: { id: _vm.detailsID },
                            })
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("QuotationCenter.edit")))]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", size: "mini", plain: "" },
                        on: {
                          click: function ($event) {
                            return _vm.onExport("freight")
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("QuotationCenter.export")))]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", size: "mini", plain: "" },
                        on: {
                          click: function ($event) {
                            return _vm.$router.push({
                              name: "BusinessQuotationTrialCalculation",
                              query: {
                                id: _vm.detailsID,
                                supplierName: _vm.supplierName,
                                logisticsChannelName: _vm.logisticsChannelName,
                              },
                            })
                          },
                        },
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("QuotationCenter.trialCalculation"))
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              2
            ),
            _c(
              "el-table",
              {
                ref: "freightTable",
                staticClass: "rate-table",
                class: { "rate-table--ready": _vm.tablesReady },
                attrs: {
                  data: _vm.freightData,
                  stripe: "",
                  border: "",
                  "header-cell-style": _vm.$rowStyle.DEFAULT,
                  "max-height": "442px",
                },
              },
              [
                _c("el-table-column", {
                  attrs: {
                    type: "index",
                    label: _vm.$t("QuotationCenter.serialNumber"),
                    align: "center",
                    width: "60",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "feeItem",
                    label: _vm.$t("QuotationCenter.feeItem"),
                    align: "center",
                    "min-width": "141",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  _vm.QUOTATION_FEE_ITEM.bjGet(
                                    scope.row.feeItem
                                  )
                                )
                              )
                            ),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "calcFuel",
                    label: _vm.$t("QuotationCenter.calcFuel"),
                    align: "center",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  _vm.QUOTATION_CALC_FUEL.bjGet(
                                    scope.row.calcFuel
                                  )
                                )
                              )
                            ),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "zone",
                    label: _vm.$t("QuotationCenter.zone"),
                    align: "center",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "packageType",
                    label: _vm.$t("QuotationCenter.packageType"),
                    align: "center",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  _vm.QUOTATION_PACKAGE_TYPE.bjGet(
                                    scope.row.packageType
                                  )
                                )
                              )
                            ),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "startWeight",
                    label: _vm.$t("QuotationCenter.start"),
                    align: "center",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "endWeight",
                    label: _vm.$t("QuotationCenter.end"),
                    align: "center",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "calcMethod",
                    label: _vm.$t("QuotationCenter.calcMethod"),
                    align: "center",
                    "min-width": "164",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  _vm.QUOTATION_CALC_METHOD.bjGet(
                                    scope.row.calcMethod
                                  )
                                )
                              )
                            ),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "unitWeight",
                    label: _vm.$t("QuotationCenter.components.roundingUnit"),
                    align: "center",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "unitPrice",
                    label: _vm.$t("QuotationCenter.components.unitPrice"),
                    align: "center",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.$number2money(scope.row.unitPrice, 4))
                            ),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "minimumCharge",
                    label: _vm.$t("QuotationCenter.components.minimumCharge"),
                    align: "center",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.$number2money(scope.row.minimumCharge))
                            ),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "rate-card" },
          [
            _c(
              "BjDivider",
              [
                _vm._v(" " + _vm._s(_vm.$t("QuotationCenter.otherFee")) + " "),
                _c(
                  "template",
                  { slot: "right" },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", size: "mini", plain: "" },
                        on: {
                          click: function ($event) {
                            return _vm.$router.push({
                              name: "BusinessQuotationOtherCost",
                              query: { id: _vm.detailsID },
                            })
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("QuotationCenter.edit")))]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", size: "mini", plain: "" },
                        on: {
                          click: function ($event) {
                            return _vm.onExport("otherFee")
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("QuotationCenter.export")))]
                    ),
                  ],
                  1
                ),
              ],
              2
            ),
            _c(
              "el-table",
              {
                ref: "otherFeeTable",
                staticClass: "rate-table",
                class: { "rate-table--ready": _vm.tablesReady },
                attrs: {
                  data: _vm.otherFeeData,
                  stripe: "",
                  border: "",
                  "header-cell-style": _vm.$rowStyle.DEFAULT,
                  "max-height": "442px",
                },
              },
              [
                _c("el-table-column", {
                  attrs: {
                    type: "index",
                    label: _vm.$t("QuotationCenter.serialNumber"),
                    align: "center",
                    width: "60",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "feeItem",
                    label: _vm.$t("QuotationCenter.feeItem"),
                    align: "center",
                    "min-width": "141",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  _vm.QUOTATION_FEE_ITEM.bjGet(
                                    scope.row.feeItem
                                  )
                                )
                              )
                            ),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "calcFuel",
                    label: _vm.$t("QuotationCenter.calcFuel"),
                    align: "center",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  _vm.QUOTATION_CALC_FUEL.bjGet(
                                    scope.row.calcFuel
                                  )
                                )
                              )
                            ),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "zone",
                    label: _vm.$t("QuotationCenter.zone"),
                    align: "center",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "packageType",
                    label: _vm.$t("QuotationCenter.packageType"),
                    align: "center",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  _vm.QUOTATION_PACKAGE_TYPE.bjGet(
                                    scope.row.packageType
                                  )
                                )
                              )
                            ),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "startWeight",
                    label: _vm.$t("QuotationCenter.start"),
                    align: "center",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "endWeight",
                    label: _vm.$t("QuotationCenter.end"),
                    align: "center",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "calcMethod",
                    label: _vm.$t("QuotationCenter.calcMethod"),
                    align: "center",
                    "min-width": "164",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  _vm.QUOTATION_CALC_METHOD.bjGet(
                                    scope.row.calcMethod
                                  )
                                )
                              )
                            ),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "unitWeight",
                    label: _vm.$t("QuotationCenter.components.roundingUnit"),
                    align: "center",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "unitPrice",
                    label: _vm.$t("QuotationCenter.components.unitPrice"),
                    align: "center",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.$number2money(scope.row.unitPrice, 4))
                            ),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "minimumCharge",
                    label: _vm.$t("QuotationCenter.components.minimumCharge"),
                    align: "center",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.$number2money(scope.row.minimumCharge))
                            ),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }